module.exports = __webpack_public_path__ + "img/Pulverização manual 2.ee3564da.webp";